import { GeneratedCollection } from "../generated.collection.abstraction";
import { TransactionView } from "../../../models/view/transaction/transaction.view";
import { inject, signal, Signal, WritableSignal } from "@angular/core";
import { Observable } from "rxjs";
import { LogService } from "@bitwarden/common/abstractions/log.service";
import { UserStoreService } from "@bitwarden/web-vault/app/services/store/user/user.store.service";
import { toObservable } from "@angular/core/rxjs-interop";

export class AlignedTransactionGeneratedCollection extends GeneratedCollection<TransactionView> {
  protected log: LogService = inject(LogService);
  protected userStore: UserStoreService = inject(UserStoreService);

  protected _collection: WritableSignal<TransactionView[]> = signal<TransactionView[]>(null);
  collection: Signal<TransactionView[]> = this._collection.asReadonly();
  collection$: Observable<TransactionView[]> = toObservable(this.collection);

  update(collection: TransactionView[]): void {
    this._collection.set([...collection]);
  }

  clear(): void {
    this._collection.set(null);
  }
}
